import { Link } from 'react-router-dom';

import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import SecSeperator from './ui/SecSeperator';

import { dateFormatDate, formatDate } from './BlogDetail';

import { $FIXME, IMAGE_URL } from '../constants';
import i18n from '../localization';
import { ICombineReducerType } from '../redux/reducers';
import { addImageFallback } from '../utils/Helper/ImagePlaceholder';
import {
    contentAccordToCurrentLang,
    toCapitalCase
} from '../utils/Helper/jsHelpers';
import text_truncate from '../utils/Helper/TextTruncate';
import { useMediaQueryHook } from '../utils/Hooks/MediaQuery';

const PopularBlogs = (props: any) => {
    const { loading } = useSelector(
        (state: ICombineReducerType) => state.blogs
    );

    const { t } = useTranslation();
    return (
        <>
            {loading ? null : (
                <div className={`popular-blogs padding  ${props.className}`}>
                    {/* <div className="popular-blogs-header"> */}
                    <SecSeperator className="popular-sep" />
                    <h2 className="title">{t(props?.title)}</h2>
                    <p className="subtitle">{t(props?.subtitle)}</p>
                    {/* </div> */}
                    <div className="popular-blogs__container">
                        {props?.latestBlogs
                            ?.slice(0, 4)
                            .map((item: $FIXME, index: number) => {
                                return (
                                    <div className="blog-holder" key={index}>
                                        <Link
                                            to={`${t('/blog', {
                                                ns: 'routes'
                                            })}/${item.slug}`}
                                        >
                                            <PopularCard
                                                image={item?.image}
                                                title={
                                                    contentAccordToCurrentLang(
                                                        item
                                                    )?.title
                                                }
                                                desc={
                                                    contentAccordToCurrentLang(
                                                        item
                                                    )?.description
                                                }
                                                type={
                                                    contentAccordToCurrentLang(
                                                        item.category
                                                    ).category
                                                }
                                                date={item?.createdAt}
                                                author={item?.author?.name}
                                            />
                                        </Link>
                                    </div>
                                );
                            })}
                    </div>
                </div>
            )}
        </>
    );
};
export default PopularBlogs;

export const PopularCard = (props: $FIXME) => {
    return (
        <div className="popular-card">
            <div className="popular-image">
                <img
                    src={IMAGE_URL + props.image}
                    alt="cars"
                    onError={addImageFallback}
                    loading="lazy"
                />
            </div>
            <div className="popular-content">
                <div
                    className="blog-type"
                    dir={i18n.language === 'ar' ? 'rtl' : 'ltr'}
                >
                    {toCapitalCase(props.type)}
                </div>
                <h1
                    className="popular-title"
                    dir={i18n.language === 'ar' ? 'rtl' : 'ltr'}
                >
                    {text_truncate(props.title, 35, '...')}
                </h1>
                <div className="date-author">
                    <p className="date">
                        {dateFormatDate(props.date.substring(0, 10))}
                    </p>
                    <span>᛫</span>
                    <p className="selects-prefixicon">
                        <span className="user-icon">
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="16"
                                height="16"
                                viewBox="0 0 16 16"
                                fill="none"
                            >
                                <path
                                    d="M8 9.99969C10.2091 9.99969 12 8.20883 12 5.99969C12 3.79056 10.2091 1.99969 8 1.99969C5.79086 1.99969 4 3.79056 4 5.99969C4 8.20883 5.79086 9.99969 8 9.99969Z"
                                    stroke="#8B8B8B"
                                    strokeWidth="1.5"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                />
                                <path
                                    d="M1.93677 13.4991C2.55149 12.4351 3.4354 11.5516 4.49969 10.9373C5.56399 10.323 6.77119 9.99968 8.00003 9.99969C9.22886 9.99971 10.4361 10.3231 11.5003 10.9374C12.5646 11.5517 13.4485 12.4352 14.0632 13.4992"
                                    stroke="#8B8B8B"
                                    strokeWidth="1.5"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                />
                            </svg>
                        </span>
                        {useMediaQueryHook() ? (
                            <span className="date">
                                {text_truncate(props.authors, 10, '...') ??
                                    'Auto24 Team'}{' '}
                            </span>
                        ) : (
                            <span className="date">
                                {props.authors ?? 'Auto24 Team'}
                            </span>
                        )}
                    </p>
                </div>
            </div>
        </div>
    );
};
